import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const Caution: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 60 60'>
      <path
        d='M59.3871 51.6129L33.8709 4.83871C32.9032 3.22581 31.2903 2.41935 29.6774 2.41935C28.0645 2.41935 26.4516 3.22581 25.4839 4.83871L0.612904 51.6129C-0.354839 53.2258 -0.354839 55.1613 0.612904 56.7742C1.58065 58.3871 3.19355 59.1935 5.12903 59.1935H54.8709C56.8064 59.1935 58.4193 58.3871 59.3871 56.7742C60.3548 55.1613 60.3548 53.2258 59.3871 51.6129ZM32.9032 50.6452H26.4516V44.1935H32.9032V50.6452ZM32.9032 37.7419H26.4516V18.3871H32.9032V37.7419Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};
